
<app-coverage-modal></app-coverage-modal>

<!-- <app-google-analytics></app-google-analytics> -->

<router-outlet></router-outlet>


<!-- <button mat-fab color="accent" class="fixed bottom-8 right-8 rounded-full z-999" (click)="redirectToWhatsApp()">
    <mat-icon svgIcon="heroicons_solid:chat-bubble-left-right"></mat-icon>
</button> -->

